import { snakeCase } from 'lodash';
import { useLocalStorage } from './use-local-storage';
export var AccountFeature = /*#__PURE__*/ function(AccountFeature) {
    AccountFeature["Timesheets"] = "timesheets";
    AccountFeature["Financials"] = "financials";
    AccountFeature["Invoices"] = "invoices";
    AccountFeature["SprintPlanning"] = "sprintPlanning";
    AccountFeature["AiFills"] = "aiFills";
    AccountFeature["AiCredits"] = "aiCredits";
    AccountFeature["AiFilter"] = "aiFilter";
    AccountFeature["Epics"] = "epics";
    AccountFeature["Backlogs"] = "backlogs";
    AccountFeature["Expenses"] = "expenseManagement";
    AccountFeature["Taxes"] = "taxes";
    AccountFeature["CreditNotes"] = "creditNotes";
    AccountFeature["DashboardV2"] = "dashboardV2";
    AccountFeature["ForcePrivateAttachments"] = "forcePrivateAttachments";
    AccountFeature["TimesheetPolicies"] = "timesheetPolicies";
    AccountFeature["Scim"] = "scim";
    AccountFeature["RestrictUserGroups"] = "restrictUserGroups";
    AccountFeature["PartnerRbac"] = "partnerRbacEnabled";
    AccountFeature["MultiLineBudgets"] = "multiLineBudgets";
    AccountFeature["EmailIntelligence"] = "emailIntelligence";
    AccountFeature["NewUI"] = "newUI";
    AccountFeature["DashboardRestrictedVisibility"] = "dashboardRestrictedVisibility";
    AccountFeature["MigrationAgent"] = "migrationAgent";
    AccountFeature["PolicyEvaluation"] = "policyEvaluation";
    AccountFeature["WorkforceAgent"] = "workforceAgent";
    AccountFeature["WorkforceAgentBuilderEnabled"] = "workforceAgentBuilderEnabled";
    AccountFeature["AutopilotAgent"] = "autopilotAgent";
    AccountFeature["CustomReportsBudgetSourceTabular"] = "customReportsBudgetSourceTabular";
    AccountFeature["CustomReportsBudgetSourcePivot"] = "customReportsBudgetSourcePivot";
    AccountFeature["OverallFinancialsOptimization"] = "overallFinancialsOptimization";
    AccountFeature["SlackPvtChannels"] = "slackPvtChannels";
    AccountFeature["RmAggregationsOpt"] = "rmAggregationsOpt";
    AccountFeature["LitePayloadRefactor"] = "litePayloadRefactor";
    AccountFeature["MeetingSettingsV2"] = "meetingSettingsV2";
    AccountFeature["NitroAnalyst"] = "nitroAnalyst";
    AccountFeature["MeetingIntelligence"] = "meetingIntelligence";
    AccountFeature["NetsuiteIntegration"] = "netsuiteIntegration";
    AccountFeature["PlanPagination"] = "planPagination";
    return AccountFeature;
}({});
export const useAccountFeature = (feature)=>{
    const resp = useLocalStorage(`__account_features.${snakeCase(feature)}`, false);
    if (feature === "planPagination") {
        return [
            true,
            resp[1]
        ];
    }
    return resp;
};
